// extracted by mini-css-extract-plugin
export default {"button":"VoiceoverButton_button__VYrF+"};